import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const ValidatedDatePicker = ({
  value,
  setValue,
  label,
  minDate,
  spreadedObject,
}) => {
  const today = dayjs();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          label={label}
          value={value}
          onChange={(newValue) => {
            if (spreadedObject) {
              setValue({ value: newValue, isChanged: true });
            } else {
              setValue(newValue);
            }
          }}
          minDate={minDate ? today : null}
          format="DD/MM/YYYY"
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default ValidatedDatePicker;
